<template>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLabel">Firma conforme cliente</h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal"><i class="icon-close-cross-white icon-btn"></i></button>
      </div>
      <div class="modal-body">
        <div class="canvas-container">
          <canvas id="firmaConformeClienteCanvas" ref="canvas">
          </canvas>
        </div>
        <div class="row row-buttons">
          <p class="col col-4 clear-button text-center"><button class="btn btn-block btn-secondary-negative" v-on:click="clearPad">&times; BORRAR</button></p>
          <p class="col col-8 accept-button text-center"><button class="btn btn-block btn-primary-negative" v-on:click="savePad">ACEPTAR</button></p>
        </div>
        <div class="alert alert-warning" v-if="alertMessage">
          {{ alertMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SignaturePad from 'signature_pad';
import apiService from '../../services/api-service.js';

export default {
  props: [
    "ticketId",
    "modalElementId",
  ],
  data() {
    return {
      signaturePad: null,
      canvas: null,
      winResizedAfterCanvas: true,
      isSendingImage: false,
      alertMessage: ''
    }
  },
  mounted() {
    this.canvas = this.$refs.canvas;
    this.signaturePad = new SignaturePad(this.canvas, {
      penColor: '#284080',
      backgroundColor: '#FFFFFF'
    });
    window.addEventListener("resize", this.onWinResize);
    $('#' + this.modalElementId).on('shown.bs.modal', this.resizeCanvas);
  },
  methods: {
    resizeCanvas() {
      if(this.winResizedAfterCanvas) {
        var ratio =  Math.max(window.devicePixelRatio || 1, 1);
        this.canvas.width = this.canvas.offsetWidth * ratio;
        this.canvas.height = this.canvas.offsetHeight * ratio;
        this.canvas.getContext("2d").scale(ratio, ratio);
        this.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
        this.winResizedAfterCanvas = false;
      }
    },
    onWinResize() {
      this.winResizeAfterCanvas = true;
    },
    savePad() {
      this.isSendingImage = true;
      this.alertMessage = "";
      axios({
        method: 'put',
        url: apiService.ajaxUrl + '-ticket/' + this.ticketId + '/firma-conforme-cliente',
        data: {
          dataUrl: this.signaturePad.toDataURL('image/jpeg'),
        }
      }).then(response => {
        if(response.data.status == apiService.STATUS_OK) {
          this.isSendingMessage = false;
          this.signaturePad.clear();
          this.closeModal();
          location.reload();
        } else {
          this.isSendingMessage = false;
          this.alertMessage = "Error: " + response.data.message;
        }
      }).catch(error => {
        this.isSendingMessage = false;
        this.alertMessage = "Error de conexión";
        console.log(error);
      });
    },
    clearPad() {
      this.signaturePad.clear();
    },
    closeModal() {
      $('#' + this.modalElementId).modal('hide');
    }
  }
}
</script>
